import React, { useRef, useEffect, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import PlanCost from '../other/userProfile/PlanCost';
import { TCPage } from '../../../Routes/RouterPage';
import Header from '../../../Frontend/Header';
import Footer from '../../../Frontend/Footer';
import { PPPage, BAPage, Login } from '../../../Routes/RouterPage';
import $ from "jquery";
import { toast } from 'react-toastify';
import Toastify from '../../../component/toast';
import StripePaymentModal from "./StripePaymentModal";

function Register() {
    const VALID_PROMO_CODES = {
        NN60FREE: { type: 'free_trial', days: 60 },
        NN60FREEJS: { type: 'free_trial', days: 60 }
    };
    const [promoCode, setPromoCode] = useState('NN60FREE');
    const [promoStatus, setPromoStatus] = useState(true); // true | false | null
    const [promoInfo, setPromoInfo] = useState(null);

    var CustomHttp = require('../CustomHttp')
    const formVal = useRef(null)
    const initOptions = [
        { id: '0', name: 'Select State', short_code: '' }
    ];
    const [options, setOptions] = useState(initOptions)
    const [physicalAddress, setPhysicalAddress] = useState('')
    const [physicalState, setPhysicalState] = useState(0)
    const [physicalZipcode, setPhysicalZipcode] = useState('')
    const [physicalCity, setPhysicalCity] = useState('')
    const [billingAddress, setBillingAddress] = useState('')
    const [billingState, setBillingState] = useState(0)
    const [billingZipcode, setBillingZipcode] = useState('')
    const [billingCity, setBillingCity] = useState('')   
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [registerPayload, setRegisterPayload] = useState(null);
    const [emailExists, setEmailExists] = useState(false);
    const [usernameExists, setUsernameExists] = useState(false);
    const [canContinue, setCanContinue] = useState(false);
    const history = useNavigate();
    const loadState = async () => {
        var myData = await CustomHttp.getRequest('/state');
        if(myData) {
            setOptions(myData.data);
        }
    }
    const sameAsPhysical = (e) => {
        if(formVal.current['same_as_physical'].checked) {
            setBillingAddress(physicalAddress)                            
            setBillingZipcode(physicalZipcode)
            setBillingCity(physicalCity)
        } else {
            setBillingAddress(billingAddress)
            setBillingZipcode(billingZipcode)
            setBillingCity(billingCity)
        }
    }
    const sameAsPhysicalCity = (e) => {            
        if(formVal.current['same_as_physical'].checked) {
            setBillingCity(e);
        } else {
            setBillingCity(billingCity);
        }            
    }
    const sameAsPhysicalState = (e) => {
        if(formVal.current['same_as_physical'].checked) {
            setBillingState(e);
        } else {
            setBillingState(billingState);
        }
    }
    const onChangePhysicalCity = (e) => {                       
        sameAsPhysicalState(e.target.value);            
    }
    const [passwordMismatch,setPasswordMismatch] = useState(false)
    const password2Handler = e => {
        const password1= formVal.current['password'].value;
        const val = e.target.value;
        if(val.length >= 6){
            if(val !== password1){
                setPasswordMismatch(true)
            } else {
                setPasswordMismatch(false)
            }
        } else {
            setPasswordMismatch(false)
        }
    }
    const password1Handler = e => {
        const password2= formVal.current['password2'].value;
        const val = e.target.value;
        if(password2.length >= 6){
            if(val !== password2){
                setPasswordMismatch(true)
            } else {
                setPasswordMismatch(false)
            }
        } else {
            setPasswordMismatch(false)
        }
    }
    const [planCost, setPlanCost] = useState("")
    const handleSubmit = async (event) => {
        event.preventDefault();
        let isValidate = window.registerFormValidation();
        if (!isValidate) return;
        if (passwordMismatch) {
            toast.error("Password doesn't match");
            return;
        }
        const email = formVal.current['email'].value;
        const username = formVal.current['username'].value;
        const emailCheck = await CustomHttp.getRequest('/check-email?email=' + email);
        const userCheck = await CustomHttp.getRequest('/check-username?username=' + username);
        if (emailCheck.status) {
            toast.error("Email address already registered");
            setEmailExists(true);
            return;
        }
        if (userCheck.status) {
            toast.error("Username already taken");
            setUsernameExists(true);
            return;
        }
        const payload = {
            first_name: formVal.current['first_name'].value,
            last_name: formVal.current['last_name'].value,
            email,
            practice_name: formVal.current['practice_name'].value,
            username,
            password: formVal.current['password'].value,

            phone_number: formVal.current['phone'].value,
            signature: formVal.current['signature'].value,

            phy_address: formVal.current['phy_address'].value,
            phy_state: formVal.current['phy_state'].value,
            phy_city: formVal.current['phy_city'].value,
            phy_zipcode: formVal.current['phy_zipcode'].value,

            billing_address: formVal.current['billing_address'].value,
            billing_state: formVal.current['billing_state'].value,
            billing_city: formVal.current['billing_city'].value,
            billing_zipcode: formVal.current['billing_zipcode'].value,

            package: formVal.current['package'].value,
            members: planCost,
            promo_code: promoCode || null,

            toc: formVal.current['toc'].value,
            pp: formVal.current['pp'].value,
            ba: formVal.current['ba'].value,
            qacd: formVal.current['qacd'].value,
        };
        setRegisterPayload(payload);
        setShowPaymentModal(true);
        setCanContinue(false);
    };
    const handleRegistration = async (payload) => {
        setCanContinue(false);
        const registerRes = await CustomHttp.postRequest("/register", payload);
        if (registerRes.status) {
            toast.success(
                registerRes.message
            );
            setTimeout(() => {
                history(Login.link);
                setCanContinue(true);
                setShowPaymentModal(false);
            }, 3000);
        } else {
            toast.warning(
                registerRes.message
            );
            setCanContinue(true);
            setShowPaymentModal(false);
        }
    }
    const handleEmailBlur = async (e) => {
        const email = e.target.value;
        setEmailExists(false);
        $("#email-unique-error").hide();
        if (!email) return;
        const res = await CustomHttp.getRequest('/check-email?email=' + email);
        if (res.status) {
            setEmailExists(true);
            $("#email-unique-error").html('Email address already registered').show();
        }
    };
    const handleUserBlur = async (e) => {
        const username = e.target.value;
        setUsernameExists(false);
        $("#username-unique-error").hide();
        if (!username) return;
        const res = await CustomHttp.getRequest('/check-username?username=' + username);
        if (res.status) {
            setUsernameExists(true);
            $("#username-unique-error").html('Username is already taken').show();
        }
    };

    const validatePromoCode = (code) => {
        const formatted = code.trim().toUpperCase();

        if (!formatted) {
            setPromoStatus(null);
            setPromoInfo(null);
            return;
        }

        if (VALID_PROMO_CODES[formatted]) {
            setPromoStatus(true);
            setPromoInfo(VALID_PROMO_CODES[formatted]);
            setCanContinue(true);
        } else {
            setPromoStatus(false);
            setCanContinue(false);
            setPromoInfo(null);
        }
    };


    useEffect(() => {        
        loadState();   
        if (
            !emailExists &&
            !usernameExists &&
            !passwordMismatch
        ) {
            setCanContinue(true);
        } else {
            setCanContinue(false);
        } 
    }, [emailExists, usernameExists, passwordMismatch]);

    return (
        <>
            <Toastify/>
            <Header />
                <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" style={{backgroundImage: 'url(/metronic8/demo2/assets/media/illustrations/sigma-1/14.png',position:"relative"}}>                    
                    <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">                        
                        <div className="w-lg-600px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto rgForm">  
                            <form className="form w-100" noValidate="novalidate" id="registerForm" action="/register" ref={formVal} onSubmit={handleSubmit}>                            
                                <div className="mb-10 text-center">                            
                                    <h1 className="text-dark mb-3">Create an Account</h1>                                                        
                                    <div className="text-gray-400 fw-bold fs-4">Already have an account? &nbsp;
                                        <Link to="/login" className="link-primary fw-bolder">Sign in here</Link>
                                    </div>                            
                                </div>                                                        
                                <div className="d-flex align-items-center mb-10">
                                    <div className="border-bottom border-gray-300 mw-50 w-100">
                                    </div>
                                    <span className="fw-bold text-gray-400 fs-7 mx-2">OR</span>
                                    <div className="border-bottom border-gray-300 mw-50 w-100">
                                    </div>
                                </div>                                                        
                                <div className="row fv-row mb-7">                            
                                    <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6"><span className="required">First Name</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="first_name" autoComplete="off" />
                                    </div>                                                        
                                    <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6"><span className="required">Last Name</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="last_name" autoComplete="off" />
                                    </div>                            
                                </div>                                                        
                                <div className="row fv-row mb-7">
                                    <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6"><span className="required">Email</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="email" autoComplete="off" onBlur={handleEmailBlur} />
                                        <em id="email-unique-error" class="error"></em>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="form-label fs-6 fw-bolder text-dark"><span className="required">Practice name</span></label>
                                        <input className="form-control form-control-lg form-control-solid mb-2" type="text" name="practice_name" autoComplete="off" />
                                    </div>
                                </div>                                                        
                                <div className="row fv-row mb-7">
                                <div className="col-xl-6">
                                        <label className="form-label fs-6 fw-bolder text-dark"><span className="required">Username</span></label>
                                        <input className="form-control form-control-lg form-control-solid mb-2" type="text" name="username" autoComplete="off" onBlur={handleUserBlur} />
                                        <em id="username-unique-error" class="error"></em>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6"><span className="required">Password</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="password" name="password" onChange={password1Handler} autoComplete="off" />
                                    </div>
                                </div>                                                        
                                <div className="row fv-row mb-7">
                                <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6"><span className="required">Confirm Password</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="password" name="password2" autoComplete="off" onChange={password2Handler} />
                                        {passwordMismatch && <em class="error">Password doesn't match.</em>}
                                    </div>
                                    {/* <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6">Company Name</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="companyName" autoComplete="off" />
                                    </div> */}
                                    <div className="col-xl-6">
                                        <label className="form-label fw-bolder text-dark fs-6">Phone Number</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="phone" autoComplete="off" />
                                    </div>
                                </div>     
                                <div className="fv-row mb-7">
                                        <label className="form-label"><span className="required  fw-bolder text-dark fs-6">Signature</span> <span className='fw-bold text-gray-700 fs-6'>(This is how your documents  will be signed)</span></label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="signature" autoComplete="off" placeholder='John Smith, LCP, PHD' />
                                    </div>                                                     
                                <div className="fv-row mb-7">
                                    <label className="form-label fw-bolder text-dark fs-6">Physical Address </label>
                                    <input className="form-control form-control-lg form-control-solid" type="text" name="phy_address" autoComplete="off"  value={physicalAddress} onKeyUp={() => sameAsPhysical()} onChange={(e) => { setPhysicalAddress(e.target.value); }} />
                                </div>                                                        
                                <div className="row fv-row mb-7">                            
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">State</label>
                                        <select name="phy_state" className="form-select form-select-solid" id="physicalState" value={physicalState} onChange={(e) => { setPhysicalState(prevState => prevState = e.target.value); onChangePhysicalCity(e);  }}>                                
                                        <option value={0}>Select State</option>
                                        {options.map((localState, index) => (
                                            <option key={localState.id+'_'+index} value={localState.id}>{localState.name}</option>
                                        ))}
                                        </select>
                                    </div>        
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">City</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="phy_city" autoComplete="off" value={physicalCity} onKeyUp={() => sameAsPhysical()} onChange={(e) => setPhysicalCity(e.target.value)} />
                                    </div>                                               
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">Zip Code</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="phy_zipcode" autoComplete="off" value={physicalZipcode} onKeyUp={() => sameAsPhysical()} onChange={(e) => setPhysicalZipcode(e.target.value)} />
                                    </div>                            
                                </div>                                                        
                                <div className="fv-row mb-7">
                                    <label className="form-check form-check-custom form-check-solid form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="same_as_physical" onChange={() => {sameAsPhysical(); sameAsPhysicalCity(physicalCity); sameAsPhysicalState(physicalState);}} defaultValue={1} />
                                        <span className="form-check-label fw-bold text-gray-700 fs-6">
                                            Same as Physical Address
                                        </span>
                                    </label>
                                </div>                                                        
                                <div className="fv-row mb-7">
                                    <label className="form-label fw-bolder text-dark fs-6">Billing Address </label>
                                    <input className="form-control form-control-lg form-control-solid" type="text" name="billing_address" autoComplete="off" value={billingAddress} onChange={(e) => setBillingAddress(e.target.value)} />
                                </div>                                                        
                                <div className="row fv-row mb-7">                            
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">State</label>
                                        <select name="billing_state" className="form-select form-select-solid" value={billingState} onChange={(e) => { setBillingState(e.target.value); }}>
                                        <option value={0}>Select State</option>
                                        {options.map((localState, index) => (
                                            <option key={localState.id+'_'+index} value={localState.id}>{localState.name}</option>
                                        ))}
                                        </select>
                                    </div>                                                        
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">City</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="billing_city" autoComplete="off" value={billingCity} onChange={(e) => setBillingCity(e.target.value)} />
                                    </div>                                                   
                                    <div className="col-xl-4">
                                        <label className="form-label fw-bolder text-dark fs-6">Zip Code</label>
                                        <input className="form-control form-control-lg form-control-solid" type="text" name="billing_zipcode" autoComplete="off" value={billingZipcode} onChange={(e) => setBillingZipcode(e.target.value)} />
                                    </div>                            
                                </div>  

                                <PlanCost minVal={1} shareIdAndCost={(value, val_package) => { setPlanCost(val_package) }}>
                                    <div className="col-xl-4">
                                            <label className="form-label text-dark fs-6 fw-bolder">Promo code</label>  
                                            <input
                                                className="form-control form-control-lg form-control-solid"
                                                type="text"
                                                name="promo_code"
                                                placeholder="Enter Promocode"
                                                autoComplete="off"
                                                value={promoCode}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    setPromoCode(val);
                                                    validatePromoCode(val);
                                                }}
                                            />

                                            {promoStatus === true && (
                                                <p style={{ color: "green", fontWeight: 600, marginBottom: "5px" }}>
                                                    🎉 Congratulations! You will not be charged until free trial ends.
                                                </p>
                                            )}

                                            {promoStatus === false && (
                                                <p style={{ color: "red", fontWeight: 600, marginBottom: "5px" }}>
                                                    ❌ Invalid promo code
                                                </p>
                                            )}

                                    </div> 
                                </PlanCost>                            
                                
                                <div className="fv-row mb-7 toc_container">
                                    <label className="form-check form-check-custom form-check-solid form-check-inline">
                                        <input className="form-check-input" type="checkbox" id="toc" name="toc" defaultValue={1} />
                                        <span className="form-check-label fw-bold text-gray-700 fs-6">I have read and agree to all of the <a href={TCPage.link} target="_blank" rel="noreferrer">terms and conditions</a> </span>
                                    </label>
                                </div>
                                <div className="fv-row mb-7 pp_container">
                                    <label className="form-check form-check-custom form-check-solid form-check-inline">
                                        <input className="form-check-input" type="checkbox" id="pp" name="pp" defaultValue={1} />
                                        <span className="form-check-label fw-bold text-gray-700 fs-6">I have read and agree to all of the <a href={PPPage.link} target="_blank" rel="noreferrer">privacy policy </a></span>
                                    </label>
                                </div>
                                <div className="fv-row mb-7 ba_container">
                                    <label className="form-check form-check-custom form-check-solid form-check-inline">
                                        <input className="form-check-input" type="checkbox" id="ba" name="ba" defaultValue={1} />
                                        <span className="form-check-label fw-bold text-gray-700 fs-6">I have read and agree to all of the <a href={BAPage.link} target="_blank" rel="noreferrer">business associate agreement </a></span>
                                    </label>
                                </div>                                                        
                                <div className="fv-row mb-10 qacd_container">
                                    <label className="form-check form-check-custom form-check-solid form-check-inline">
                                        <input className="form-check-input" type="checkbox" id="qacd" name="qacd" defaultValue={1} />
                                        <span className="form-check-label fw-bold text-gray-700 fs-6">I understand that the quality and content of my documentation is my responsibility </span>
                                    </label>
                                </div>                            
                                
                                <div className="text-center">
                                    <button type="submit" id="kt_sign_up_submit" className="btn btn-lg btn-primary" disabled={!canContinue}>
                                        <span className="indicator-label">Continue</span>
                                        <span className="indicator-progress">Please wait... 
                                        <span className="spinner-border spinner-border-sm align-middle ms-2" /></span>
                                    </button>
                                </div>                            
                            </form>   
                        </div>                        
                    </div>                    
                </div>
                <StripePaymentModal
                    show={showPaymentModal}
                    close={() => setShowPaymentModal(false)}
                    save={(payload) => handleRegistration(payload)}
                    payload={registerPayload}
                />
            <Footer />
        </>
    )
}

export default Register